import React from 'react';
import { Modal } from './Modal';
import { formatVolume, sumVolume, type PipelineRecord } from '../data/pipeline';
type PipelineDrilldownModalProps = {
  title: string | null;
  subtitle?: string;
  records: PipelineRecord[];
  dateColumn: {
    label: string;
    get: (record: PipelineRecord) => number | undefined;
  };
  onClose: () => void;
};
const relative = (daysAgo?: number): string => {
  if (typeof daysAgo !== 'number') return '—';
  if (daysAgo === 0) return 'Today';
  if (daysAgo === 1) return 'Yesterday';
  return `${daysAgo} days ago`;
};
export function PipelineDrilldownModal({
  title,
  subtitle,
  records,
  dateColumn,
  onClose
}: PipelineDrilldownModalProps) {
  return <Modal open={Boolean(title)} onClose={onClose} size="wide" title={title ?? ''} subtitle={subtitle ?? `${records.length} record${records.length === 1 ? '' : 's'} · ${formatVolume(sumVolume(records))} total volume`} data-id="element-545" data-mp="e4lr0f6m34lj">
      <div className="overflow-x-auto" data-id="element-546" data-mp="xu2zw28ts5u6">
        <table className="w-full min-w-[720px] text-left" data-id="element-547" data-mp="xt1fh75x66zs">
          <thead className="border-b border-gray-200 bg-gray-50 text-[11px] uppercase tracking-wider text-gray-500" data-id="element-548" data-mp="12l1jbap41k1n">
            <tr data-id="element-549" data-mp="nwevslpbxlzc">
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-550" data-mp="nwyfa6umoifh">Loan</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-551" data-mp="stx72iqtkdai">Borrower</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-552" data-mp="1gkkhpbs4dh0r">Status</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-553" data-mp="1gig9wir3nxv7">Purpose</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-554" data-mp="1lim6mdc88ak5">LOA</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-555" data-mp="16lbowm8zq8fz">Amount</th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-556" data-mp="1bkety6oz0eny">
                {dateColumn.label}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-[13px]" data-id="element-557" data-mp="3reox9yf52gne">
            {records.map(record => <tr key={record.id} className="hover:bg-gray-50" data-id="element-558" data-mp="22sq4zipd5myc">
                <td className="px-5 py-3 font-medium text-ink" data-id="element-559" data-mp="22s6jjs0i8gfk">{record.number}</td>
                <td className="px-5 py-3" data-id="element-560" data-mp="1xuy3bwyx2mgy">
                  <a href={`#/loans/${record.number}`} onClick={event => event.preventDefault()} title={`Open ${record.number} · ${record.borrower}`} className="font-medium text-brand underline decoration-brand/40 underline-offset-2 transition-colors hover:text-brand-dark hover:decoration-brand" data-id="element-561" data-mp="1xvzhwbf55r3f">
                    {record.borrower}
                  </a>
                </td>
                <td className="px-5 py-3 text-gray-600" data-id="element-562" data-mp="1a4apyw68f4n0">{record.status}</td>
                <td className="px-5 py-3 text-gray-600" data-id="element-563" data-mp="15698ugsd9fe6">{record.purpose}</td>
                <td className="px-5 py-3 text-gray-600" data-id="element-564" data-mp="34ibqdlhfjzp7">{record.assistant}</td>
                <td className="px-5 py-3 text-ink" data-id="element-565" data-mp="2zj8kjytmlpg6">{formatVolume(record.amount)}</td>
                <td className="px-5 py-3 text-gray-600" data-id="element-566" data-mp="2zh5szactro9c">
                  {relative(dateColumn.get(record))}
                </td>
              </tr>)}
            {records.length === 0 && <tr data-id="element-567" data-mp="3gsb3kniprt6u">
                <td colSpan={7} className="px-5 py-12 text-center text-[13px] text-gray-500" data-id="element-568" data-mp="3grrnzdgjdgvz">
                  No records match this tile with the current filters.
                </td>
              </tr>}
          </tbody>
        </table>
      </div>
    </Modal>;
}